import React from "react";
import { Modal } from "antd";
import { modalFooter, modalTitle } from "../../../components";

interface BulkImportReportProps {
  open: boolean;
  onCancel: () => void;
  successMessage: string;
  errors: string[];
}

export const BulkImportReport: React.FC<BulkImportReportProps> = ({
  open,
  onCancel,
  successMessage,
  errors,
}) => {
  return (
    <Modal
      title={modalTitle("Excel Bulk Import Report")}
      open={open}
      onCancel={onCancel}
      footer={modalFooter({
        actions: [{ label: "Close", type: "primary", onClick: onCancel }],
      })}
      width={650}
      destroyOnClose
    >
      {successMessage && (
        <div className="p-4 bg-emerald-50 border border-emerald-200 rounded-lg text-emerald-800 flex flex-col items-center gap-2">
          <span className="text-sm font-semibold uppercase tracking-wide">
            Import completed
          </span>
          <p className="font-semibold text-base m-0 text-center">
            {successMessage}
          </p>
          <p className="text-xs text-emerald-600 m-0 text-center">
            All category and brand labels have been resolved or dynamically
            created.
          </p>
        </div>
      )}

      {errors.length > 0 && (
        <div className="flex flex-col gap-3">
          <div className="p-3 bg-rose-50 border border-rose-200 rounded-lg text-rose-800 font-semibold text-sm">
            Import rolled back. Validation errors were found in the spreadsheet.
            No changes were made to the database. Please resolve the errors
            listed below and re-upload the file.
          </div>
          <div className="max-h-96 overflow-y-auto border border-gray-200 rounded-lg divide-y divide-gray-100 bg-white">
            {errors.map((err, i) => (
              <div
                key={i}
                className="p-3 text-sm text-gray-700 flex items-start gap-2 hover:bg-gray-50 transition-colors"
              >
                <span className="w-2 h-2 rounded-full bg-rose-500 mt-1.5 flex-shrink-0" />
                <span>{err}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </Modal>
  );
};
